module.exports = __webpack_public_path__ + "media/arbutin-large.b407129f.mp4";